import React, { Fragment, useState } from "react";
import AntTable from "../../common/Table";  
import { compose, graphql } from 'react-apollo';
import { removeClientM } from "../../../graphql/mutation/client";
import columns from "../../../const/columns/client";
import routes from "../../../const/routes";
import RefreshButton from "../../common/RefreshButton";
import { openNotificationWithIcon } from "../../common/Notification";
import { Spin } from "antd";

function Client({props, removeClient}){
    let [ loading, setLoading ] = useState(false); 

    async function deleteF(id){
        let body = {
            _id: id,
            removeClient 
        };
    
        await props.REMOVE_CLIENT(body);

        setTimeout(() => {props.refetch()},10)
        openNotificationWithIcon('success', "Sucesso", "Cliente deletado com sucesso", "", 7);
    }

    function update(id){
        localStorage.setItem('@Ossel:Update', true);
        localStorage.setItem('@Ossel:UpdateID', id);
    }

    function refresh(){
        setLoading(loading = true);
        setTimeout(() => {
            setLoading(loading = false);
            props.refetch();
        }, 1000);
    }
 
    return(
        <Fragment>
            <RefreshButton clickAction={refresh}/>
            <Spin spinning={loading}>
                <AntTable 
                    dataSource={props.clients ? props.clients : []} 
                    columns={columns} 
                    new={routes.CLIENTS_FORM} 
                    delete={deleteF} 
                    update={update}
                    btEdit={true}
                    btDelete={true}
                />
            </Spin>
        </Fragment>
    )
}

export default compose(
    graphql( removeClientM, { name: "removeClient" } )
)(Client);


// WEBPACK FOOTER //
// ./src/components/general/clientWrapper/Client.jsx